const CF_API_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
const CALLBACK_NAME = 'onTurnstileLoaded';

let readyPromise = null;

export default function (context, inject) {
  const configSiteKey = process.env.TURNSTILE_SITE_KEY;

  const turnstileService = {
    load() {
      if (process.server) {
        return Promise.resolve();
      }
      if (window.turnstile) {
        return Promise.resolve();
      }
      if (readyPromise) {
        return readyPromise;
      }

      readyPromise = new Promise((resolve, reject) => {
        window[CALLBACK_NAME] = () => {
          resolve();
          delete window[CALLBACK_NAME];
        };

        const script = document.createElement('script');
        script.src = `${CF_API_URL}?onload=${CALLBACK_NAME}`;
        script.async = true;
        script.defer = true;

        script.onerror = (error) => {
          console.error('Cloudflare Turnstile failed to load:', error);
          readyPromise = null;
          reject(new Error('Failed to load Cloudflare Turnstile script'));
        };

        document.head.appendChild(script);
      });

      return readyPromise;
    },

    async render(element, options = {}) {
      if (process.server) {
        return;
      }

      await this.load();

      // Use the key found in config
      const sitekey = configSiteKey;

      if (!sitekey) {
        console.error('Cloudflare Turnstile Error: Site Key is missing. Check your nuxt.config.js env configuration.');
        return;
      }

      return window.turnstile.render(element, {
        sitekey,
        ...options,
      });
    },

    async reset(widgetId) {
      if (process.server || !window.turnstile) {
        return;
      }
      await this.load();
      return window.turnstile.reset(widgetId);
    },

    remove(widgetId) {
      if (process.server || !window.turnstile) {
        return;
      }
      return window.turnstile.remove(widgetId);
    },
  };

  inject('turnstile', turnstileService);
}
